var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4957 2.90924C15.1651 2.23977 15.1697 1.15887 14.5058 0.494975C13.8419 -0.168916 12.761 -0.164394 12.0915 0.505076L9.66714 2.92944L7.26298 0.525279C6.59909 -0.138612 5.51819 -0.13409 4.84872 0.535381C4.17925 1.20485 4.17472 2.28575 4.83861 2.94965L7.24278 5.35381L4.81841 7.77817C4.14894 8.44765 4.14442 9.52855 4.80831 10.1924C5.4722 10.8563 6.5531 10.8518 7.22258 10.1823L9.64694 7.75797L12.0511 10.1621C12.715 10.826 13.7959 10.8215 14.4654 10.152C15.1348 9.48256 15.1394 8.40166 14.4755 7.73777L12.0713 5.3336L14.4957 2.90924ZM18.7 5.97229C17.7611 5.97229 17 6.73981 17 7.68658C17 8.63335 17.7611 9.40086 18.7 9.40086H28.9C29.8389 9.40086 30.6 10.1683 30.6 11.1152V14.5437C30.6 15.4905 29.8389 16.258 28.9 16.258H5.1C4.1611 16.258 3.4 15.4905 3.4 14.5437V12.8294C3.4 11.8827 2.63888 11.1152 1.7 11.1152C0.761116 11.1152 0 11.8827 0 12.8294V14.5437C0 17.3841 2.28336 19.6866 5.1 19.6866H28.9C31.7167 19.6866 34 17.3841 34 14.5437V11.1152C34 8.27478 31.7167 5.97229 28.9 5.97229H18.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.55c8628a2545ef5d634ffb7b973bb73d.svg";
export { ForwardRef as ReactComponent };